var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 740.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#ededed;}.cls-3{fill:#ea711f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.18,
    width: 1920,
    height: 740.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M936.35,365.45c-23.81-35.3-47.61-70.6-71.42-105.9-15.25-22.61-30.5-45.22-45.75-67.84h0c-6.69-9.92-10.8-21.36-11.8-33.28-5.03-59.85,41.07-114.52,104.07-116.54l1007.16-31.94.73,586.96-635.72,139.43c-59.28,15.03-118.36-13.66-148.65-67.64l-198.61-303.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M938.88,324.19c-22.66-36.05-45.32-72.09-67.99-108.14-14.52-23.09-29.03-46.18-43.55-69.27h0c-6.37-10.12-10.11-21.7-10.72-33.64-3.1-59.98,44.73-113.14,107.75-113.14h995.63v587.26l-645.94,118.77c-59.73,13.12-117.86-17.45-146.4-72.38l-188.78-309.45Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMain);
export default __webpack_public_path__ + "static/media/bg_main.0c16e7cc946e586cf49ee9a54aca85a0.svg";
export { ForwardRef as ReactComponent };